import React from 'react';
import { LIVE_SCORE_STATUS } from '../../constants';

const StatusDropdown = (props) => {
  const {
    liveScore,
    selectedDropdown,
    toggleDropDown,
    handleStatusDropdown,
  } = props;

  return (
    <div
      className={`dropdown dropdown--feed ${selectedDropdown === liveScore.competitionId && 'is-open'}`}
      onClick={toggleDropDown.bind(this, liveScore.competitionId)}
    >
      <span>{LIVE_SCORE_STATUS[liveScore.status]}</span>
      <div className="dropdown__list">
        <div
          className={`dropdown__list-item ${liveScore.status === LIVE_SCORE_STATUS.ACTIVE ? 'active' : ''}`}
          onClick={handleStatusDropdown?.bind(
            this, liveScore.competitionId, LIVE_SCORE_STATUS.ACTIVE,
          )}
        >
          Active
        </div>
        <div
          className={`dropdown__list-item ${liveScore.status === LIVE_SCORE_STATUS.MANUALY_DISABLED ? 'active' : ''}`}
          onClick={handleStatusDropdown?.bind(
            this, liveScore.competitionId, LIVE_SCORE_STATUS.MANUALY_DISABLED,
          )}
        >
          Manually Disabled
        </div>
      </div>
    </div>
  );
};
export default StatusDropdown;
